import { useSelector } from 'react-redux'
import { PermissionScope } from '../containers/Employees'
import { getUserScope } from '../reducers/userAccount/selectors/userAccount'
import { IStore } from '../reducers'

type ScopeType = PermissionScope[] | Array<Array<PermissionScope>>

type ScopeAccess<T> = {
  [Key in keyof T]: boolean
}

export function isInScope(state: IStore) {
  const userScopes = getUserScope(state)

  return function<T>(scope: T): T extends ScopeType ? boolean : ScopeAccess<T> {
    return evalScope(userScopes, scope)
  }
}

function useIsScope<T>(
  scope: T,
): T extends ScopeType ? boolean : ScopeAccess<T> {
  const userScopes = useSelector(getUserScope)

  return evalScope(userScopes, scope)
}

const evalScope = (userScopes, scope) => {
  if (!userScopes || !scope) return false as any

  if (typeof scope === 'object' && !Array.isArray(scope)) {
    const obj = {}
    Object.entries(scope).forEach(([key, value]) => {
      obj[key] = checkScope(value, userScopes)
    })

    return obj as any
  }

  return checkScope(scope, userScopes)
}

const checkScope = (scope, userScopes) => {
  return scope.every(s => {
    return userScopes.some(us => {
      if (Array.isArray(s)) {
        return s.some(ss => ss === us)
      }
      return us === s
    })
  })
}

export default useIsScope
